import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const { rendering } = props;
    const phKeyLeft = `custom-sidebar-left`;
    const phKeyRight = `custom-sidebar-right`;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col md:flex-row gap-6",
        ...getTestProps(`component-sidebar-layout-${rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "w-full md:w-1/4 flex-shrink-0",
                "data-placeholder": "editorial-left",
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeyLeft,
                    rendering: rendering,
                    ...getTestProps(`ph-left`)
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full md:w-3/4 flex-grow",
                "data-placeholder": "editorial-right",
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeyRight,
                    rendering: rendering,
                    ...getTestProps(`ph-right`)
                })
            })
        ]
    });
};
